import React from 'react';
import { Button } from './ui/button';
import { mockData } from '../data/mock';
import { useThemeLanguage } from '../context/ThemeLanguageContext';

const Hero = ({ onBookingClick }) => {
  const { t } = useThemeLanguage();
  
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white overflow-hidden pt-16 md:pt-0">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-bg-repeat"></div>
      </div>

      {/* Floating elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-white/5 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-32 right-16 w-32 h-32 bg-white/3 rounded-full blur-2xl animate-pulse delay-1000"></div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Logo/Brand */}
<div className="mb-8 transform hover:scale-105 transition-transform duration-300 flex justify-center">
  <img 
    src="/images/logo-hero.png"
    alt="Riviera Signature VTC"
    className="w-auto h-48 md:h-64 lg:h-72 object-contain"
  />
</div>

        {/* Description */} 
        <p className="text-lg md:text-s text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed font-light"> 
          {t('hero.description')} 
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <Button 
            onClick={onBookingClick}
            size="lg"
            data-testid="hero-book-btn"
            className="bg-white text-black hover:bg-gray-100 px-12 py-4 text-lg font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-2xl group"
          >
            <span className="mr-2">{t('hero.bookNow')}</span>
            <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Button>

          <Button 
            size="lg"
            data-testid="hero-services-btn"
            className="bg-white text-black hover:bg-gray-100 px-12 py-4 text-lg font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
            onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
          >
            {t('hero.discoverServices')}
          </Button>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-3 gap-8 pt-12 border-t border-white/20">
          <div className="text-center transform hover:scale-105 transition-transform">
            <div className="text-3xl font-light mb-2">2026</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">{t('hero.since')}</div>
          </div>
          <div className="text-center transform hover:scale-105 transition-transform">
            <div className="text-3xl font-light mb-2">24/7</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">{t('hero.service')}</div>
          </div>
          <div className="text-center transform hover:scale-105 transition-transform">
            <div className="text-3xl font-light mb-2">100%</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">{t('hero.satisfaction')}</div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-white opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
